import React, { Component } from 'react';

import Grid from '@mui/material/Grid2';
import { 
  CharacterFeature,
  BasicCreatureInstance,
  CreatureAbility,
  MinionAbility,
  // EncounterLog,
  CreatureSpellAsAbility,
  SummonOption2,
  CharacterSpell,
  Spell,
  CharacterAbility,
} from "@dndModels";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import CreatureAction from "@dndComponents/creature/CreatureActionInput";
import DisplayStringWithReplacements from "@dndComponents/display/DisplayStringWithReplacements";

type Props = { 
  creature_instances: BasicCreatureInstance[];
  onChange: () => void;
  onSummon: (spell: CharacterAbility | CharacterSpell | Spell | CreatureAbility | MinionAbility, level: number, selected_option: SummonOption2) => void;
}

export interface State { 
}

const char_util = DandDCharacterUtilities.getInstance();

class LairActionsInput extends Component<Props, State> {
  // public static defaultProps = {
  //   character: null
  // };
  // constructor(props: Props) {
  //   super(props);
  //   this.state = {
  //   };
  // }

  // componentDidMount() {
  // }

  // componentDidUpdate(prevProps: Props, prevState: State) {
  //   if (this.props.true_id !== prevProps.true_id) {
  //     this.setState({ reloading: true }, () => {
  //       this.setState({ reloading: false });
  //     });
  //   }
  // }

  render() {
    return (
      <Grid container spacing={0} direction="column" 
        style={{ 
          lineHeight: "1.5",
          backgroundColor: "beige",
          color: "blue"
        }}>
        <Grid
          style={{
            fontSize: "20px",
            fontWeight: "bold"
          }}>
          Lair Actions
        </Grid>
        { this.props.creature_instances.map((creature_instance, key1) => {
          return creature_instance.lair_actions.map((feature, key) => {
            return this.renderAction(creature_instance, feature, `${key1}_${key}`);
          });
        })}
      </Grid>
    );
  }

  renderAction(creature_instance: BasicCreatureInstance, feature: CharacterFeature, key: string) {
    const floating_feature = feature.floating_feature;
    if (floating_feature && 
      (floating_feature instanceof CreatureAbility || 
        // floating_feature instanceof CreatureSpellAsAbility ||
        floating_feature instanceof MinionAbility)) {
      let description = floating_feature.description;
      description = char_util.getStringWithReplacements(description, creature_instance);
      return (
        <Grid key={key} container spacing={0} direction="column">
          <Grid container spacing={0} direction="column">
            <Grid>
              <CreatureAction
                obj={creature_instance}
                char_feature={feature}
                action={floating_feature}
                disabled={false}
                onChange={() => {
                  this.props.onChange();
                  this.setState({ });
                }}
                onSummon={(selected_option: SummonOption2) => {
                  if (floating_feature instanceof CreatureSpellAsAbility) {
                    if (floating_feature.spell) {
                      this.props.onSummon(floating_feature.spell, floating_feature.spell.level, selected_option);
                    }
                  } else {
                    this.props.onSummon(floating_feature, 0, selected_option);
                  }
                }}
              />
            </Grid>
            <Grid>
              <DisplayStringWithReplacements display_string={description}
                // cfs={ this.props.creature_instance instanceof CreatureInstance ? this.props.creature_instance.creature : null }
              /> 
            </Grid>
            { feature.floating_feature instanceof CreatureSpellAsAbility && feature.floating_feature.spell &&
              <>
                <Grid style={{ fontWeight: "bold" }}>Spell Description</Grid>
                <Grid>{ feature.floating_feature.spell.description }</Grid>
              </>
            }
          </Grid>
        </Grid>
      );
    }
    return null;
  }
}

export default LairActionsInput;
